import ContentsToReact from '@/components/ContentsToReact/ContentsToReact';
import GenericModals from '@/components/GenericModals/GenericModals';
import Page from '@/components/Page/Page';
import PageHead from '@/components/PageHead/PageHead';
import { extractContents } from '@/helpers/extractContents';
import extractPageMetaFromRouteData from '@/helpers/extractPageMetaFromRouteData';
import { transformLandingPageHeaderArea } from '@/helpers/transformLandingPageHeaderArea';
import { useInitialPageDataLayer } from '@/hooks/useInitialPageDataLayer/useInitialPageDataLayer';
import type { PageModel } from '@/models/page';
import BackToTopButton from '@uikit/components/BackToTopButton/BackToTopButton';
import EegLandingPageFooter from '@uikit/components/EegLandingPageFooter/EegLandingPageFooter';
import EegLandingPageHeader from '@uikit/components/EegLandingPageHeader/EegLandingPageHeader';
import EegModal from '@uikit/components/EegModal/EegModal';
import Layout from '@uikit/components/Layout/Layout';
import { LayoutVariant } from '@uikit/components/Layout/interfaces';
import cmsComponents from './EegLandingPage.cmsComponents';

const EegDefaultPage = (pageData: PageModel) => {
  const meta = extractPageMetaFromRouteData(pageData);

  const { contents, modals } = pageData;

  const {
    extractedContents: [headerArea, noticeBarArea],
    restContents,
  } = extractContents(['eeg-landing-page-header', 'notice-bar-area'], contents);

  useInitialPageDataLayer();

  return (
    <>
      <PageHead {...meta} />
      {noticeBarArea && (
        <ContentsToReact
          contents={noticeBarArea}
          cmsComponents={cmsComponents}
        />
      )}
      <Layout variant={LayoutVariant.Default}>
        <EegLandingPageHeader {...transformLandingPageHeaderArea(headerArea)} />

        <Page>
          {restContents && (
            <ContentsToReact
              contents={restContents}
              cmsComponents={cmsComponents}
            />
          )}
        </Page>

        <BackToTopButton />

        <EegLandingPageFooter />
      </Layout>

      <GenericModals
        modals={modals}
        modalComponent={EegModal}
        cmsComponents={cmsComponents}
      />
    </>
  );
};

export default EegDefaultPage;
